module.exports = __webpack_public_path__ + "img/m-about1.78e4040a.png";